import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Product } from '../../../core/models/product.model';
import { ProductCardComponent } from '../product-card/product-card.component';
import { TranslatePipe } from '../../../core/pipes/t.pipe';
import { getScrollStepFromCard } from '../../../core/utils/carousel-scroll.util';
import { scrollCarouselCircular } from '../../../core/utils/carousel-nav.util';
import { AutoScrollDirective } from '../../directives/auto-scroll.directive';

@Component({
  selector: 'app-product-rail',
  standalone: true,
  imports: [CommonModule, ProductCardComponent, TranslatePipe, AutoScrollDirective],
  templateUrl: './product-rail.component.html',
  styleUrls: ['./product-rail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRailComponent {
  @Input({ required: true }) products: Product[] = [];
  @Input() showNav = true;
  @Input() autoScroll = true;
  @Input() ariaLabel = '';
  @Input() recentlyAddedId: number | null = null;
  @Input() isRecentlyAddedFn: ((productId: number) => boolean) | null = null;
  /** When true, every card in this rail shows the New / جديد badge (وصل حديثاً). */
  @Input() forceNew = false;

  @Output() addToCart = new EventEmitter<number>();
  @Output() buyNow = new EventEmitter<number>();
  @Output() quickPreview = new EventEmitter<Product>();

  readonly chevronLeftIcon = '/assets/icons/figma/chevron-carousel-left.svg';
  readonly chevronRightIcon = '/assets/icons/figma/chevron-carousel-right.svg';

  isRecentlyAdded(productId: number): boolean {
    const fn = this.isRecentlyAddedFn;
    if (typeof fn === 'function') {
      return fn(productId);
    }
    return this.recentlyAddedId === productId;
  }

  trackById(_index: number, product: Product): number {
    return product.id;
  }

  scrollRail(event: Event, direction: 'prev' | 'next'): void {
    const viewport = (event.currentTarget as HTMLElement | null)?.closest('.zt-carousel-viewport');
    const rail = viewport?.querySelector<HTMLElement>('.zt-product-rail-scroll');
    if (!rail) {
      return;
    }
    const step = getScrollStepFromCard(rail, '.product-card', 0.4);
    scrollCarouselCircular(rail, direction, step);
  }
}
